import React from 'react';
import Swiper from 'react-id-swiper';
import Image from 'components/Image';

const TeamCarousel = () => {
  const params = {
    Swiper,
    freeMode: true,
    freeModeMomentumBounce: false,
    loop: true,
    spaceBetween: 10,
    grabCursor: true,
    width: 3840,
  };

  return (
    <Swiper {...params}>
      <Image className="section__image" src="img-164.jpg" />
    </Swiper>
  );
};

export default TeamCarousel;
